/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { CheckCircleIcon as CheckCircleIconSolid } from "@heroicons/react/solid";

const MPSSkipPopUpModal = ({ handleClose, handleGoToDashboard}) => {

  return (
    <div className="fixed inset-0 flex items-center justify-center  bg-opacity-100">
      <div className="bg-white justify-center p-6 rounded-2xl shadow-lg max-w-md w-full">
        <div className="flex justify-center space-x-4">
          <CheckCircleIconSolid className="size-20 text-Success/700" />
        </div>
        <h2 className="justify-center text-center text-lg font-semibold mt-4 mb-6 text-grey-900">
          Proceed to save your details?
        </h2>
        {/* <p className="mb-6 text-sm text-grey-600 text-center">
          {`Don't forget to come back and finish later`}
        </p> */}
        <div className="flex justify-center space-x-4">
          <button
            className="bg-grey-25 hover:bg-grey-400 text-grey-900 font-semibold px-4 py-3 text-base rounded-lg border-2 "
            onClick={() => handleClose(false)}
          >
            No, Continue Editing
          </button>
          <button
            className=" bg-grey-700 hover:bg-grey-800  text-grey-25 px-4 py-3 text-base font-semibold rounded-lg"
            onClick={() => {
              handleGoToDashboard();
            }}
          >
            Yes, Go To Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};
export default MPSSkipPopUpModal;
